import { ConfirmationCreateDialog, type ConfirmationCreateDialogProps } from '@/components/dialogs';
import {
  useNomenclatureContextWindows,
  useNomenclatureStoreActions,
} from '@/components/nomenclature/useNomenclatureStore';

// ----------------------------------------------------------------------

export type NomenclatureConfirmationCreateDialogProps = Pick<ConfirmationCreateDialogProps, 'isLoading'> & {
  onProceed: () => Promise<void>;
};

// ----------------------------------------------------------------------

export const NomenclatureConfirmationCreateDialog = (props: NomenclatureConfirmationCreateDialogProps) => {
  const { isLoading, onProceed } = props;

  const { isConfirmationCreateDialogVisible } = useNomenclatureContextWindows();
  const { closeConfirmationCreateDialog, setPreferredTab } = useNomenclatureStoreActions();

  const handleClose = () => {
    closeConfirmationCreateDialog();
    setPreferredTab('general');
  };

  const handleProceed = async () => {
    await onProceed();
    closeConfirmationCreateDialog();
  };

  return (
    <ConfirmationCreateDialog
      open={isConfirmationCreateDialogVisible}
      isLoading={isLoading}
      onClose={handleClose}
      onProceed={handleProceed}
    />
  );
};
